import { Suspense } from "react";
import { Outlet } from "@tanstack/react-router";
import { FullPageScreen } from "@/lib/Components/Screens/FullPageScreen";
import { Spinner } from "@/lib/Components/Layout/Loaders/Spinner";

export function AdminLayout() {
  return (
    <FullPageScreen className="space-y-6">
      <Suspense
        fallback={
          <div className="flex h-full w-full items-center justify-center">
            <Spinner className="size-5" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </FullPageScreen>
  );
}
